import type { BreederListGetBreedersQuery } from '@gql/graphql';
import { BREAKPOINTS } from '@presentation/styles';
import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { useFormatBreederCard } from './useFormatBreederCard';

export const useFormatBreeders = (
  breeders?: BreederListGetBreedersQuery['findManyDogBreeder'] | null,
) => {
  const { formatBreeder } = useFormatBreederCard();

  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.phone}px)` });
  const preloadImagesCount = isMobile ? 2 : 4;

  const formattedBreeders = useMemo(() => {
    if (!breeders?.length) return undefined;
    return breeders.map((breeder, index) => formatBreeder(breeder, index >= preloadImagesCount));
  }, [breeders, formatBreeder, preloadImagesCount]);

  const imagesToPreload: string[] = useMemo(() => {
    if (!formattedBreeders?.length) return [];
    return formattedBreeders.slice(0, preloadImagesCount).map((breeder) => breeder.image as string);
  }, [formattedBreeders, preloadImagesCount]);

  return { formattedBreeders, formatBreeder, imagesToPreload };
};
